import React, { useEffect, useReducer, useState } from 'react'
import { produce, enableES5 } from 'immer'
import { reducer } from './reducer'

enableES5()

const initialState = {
   store: {},
   dispatch: () => {},
   activeStep: 1,
   disableNext: false,
   setActiveStep: () => {},
   setDisableNext: () => {},
   isSubmitted: false
}

const initialStore = {
   pupil: {},
   guardians: [{}, {}],
   siblings: [],
   fritids: {}
}

// Wrap reducer in Immer producer
const curriedReducer = produce(reducer)

export const AppContext = React.createContext(initialState)

export const WithAppContext = ({ children }) => {
   const [store, dispatch] = useReducer(curriedReducer, initialStore)
   const [disableNext, setDisableNext] = useState(false)
   const [activeStep, setActiveStep] = useState(1)
   const [isLoading, setIsLoading] = useState(true)
   const [isSubmitted, setIsSubmitted] = useState(false)

   // Handle what state the view is in
   useEffect(() => {
      // Make sure app is in renderable state
      if (!isLoading) return
      setIsLoading(false)
   }, [isLoading])

   const contextState = {
      store,
      dispatch,
      disableNext,
      setDisableNext,
      activeStep,
      setActiveStep,
      isLoading,
      setIsLoading,
      isSubmitted,
      setIsSubmitted
   }

   return (
      <AppContext.Provider value={contextState}>{children}</AppContext.Provider>
   )
}
